import { render } from "./LightboxJS.vue?vue&type=template&id=1c65a2b5"
import script from "./LightboxJS.vue?vue&type=script&lang=js"
export * from "./LightboxJS.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__